import BaseImage from './BaseImage'
export default BaseImage
